module.exports = __webpack_public_path__ + "static/img/null.e1fc7083.png";